module.exports = __webpack_public_path__ + "media/emails/header-green-e37a0452.png";